import React from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import data from '../data/paomakeup';
import { useFetch } from '../hooks/useApiCall';
import { getCategories } from '../services/serviceService';
import { PmLoading, PmError } from '../components/pm/PmStates';
import { IconStar } from '../components/pm/PmIcons';
import { SERVICES, ROUTES } from '../data/pmContent';

/* Datos editoriales de la home (badge, "desde", facts) indexados por slug,
   para enriquecer las categorías que llegan del API. */
const PM_BY_SLUG = Object.fromEntries(SERVICES.map((s) => [s.slug, s]));

const OurServices = () => {
  const { data: categories, loading, error, refetch } = useFetch(getCategories);

  return (
    <div className="pm-scope page">
      <Helmet>
        <title>Nuestros servicios - {data.title}</title>
        <meta name="description" content={data.our_services_price_description} />
        <meta name="keywords" content={data.our_services_price_keywords} />
        <meta property="og:title" content={`Nuestros servicios - ${data.title}`} />
        <meta property="og:type" content="article" />
        <meta property="og:url" content="/nuestros-servicios" />
        <meta property="og:site_name" content="PaoMakeup Beauty Studio" />
        <meta property="og:description" content={data.our_services_price_description} />
      </Helmet>

      <section className="section">
        <div className="container">
          <div className="section-head section-head--center">
            <span className="eyebrow eyebrow--center">Nuestros servicios</span>
            <h1 className="text-balance">Todo lo que necesitas para verte y sentirte bien</h1>
            <p>Siete áreas de servicio bajo el mismo techo, con el mismo estándar de acabado.</p>
          </div>

          {loading && <PmLoading message="Cargando los servicios…" />}
          {error && <PmError message={error} onRetry={refetch} />}

          {categories && categories.length > 0 && (
            <div className="services__grid">
              {categories.map((category) => {
                const pm = PM_BY_SLUG[category.slug] || {};
                return (
                  <article className="service" key={category.id}>
                    <div className="service__media">
                      {pm.badge && <span className="service__badge">{pm.badge}</span>}
                      {(category.image_url || pm.image) ? (
                        <img
                          src={category.image_url || pm.image}
                          alt={pm.imageAlt || category.name}
                          loading="lazy"
                          decoding="async"
                        />
                      ) : (
                        <div className="service__placeholder" aria-hidden="true">
                          <IconStar width="52" height="52" />
                        </div>
                      )}
                    </div>
                    <div className="service__body">
                      <h3>{pm.title || category.name}</h3>
                      <p>{pm.text || category.description}</p>
                      <div className="service__facts">
                        {pm.priceFrom && <span className="service__fact">{pm.priceFrom}</span>}
                        {pm.fact && <span className="service__fact">{pm.fact}</span>}
                      </div>
                      <div className="service__actions">
                        <Link className="btn btn--secondary btn--sm" to={`/nuestros-servicios/${category.slug}/precios`}>
                          Ver precios
                        </Link>
                        <Link className="btn btn--primary btn--sm" to={ROUTES.agendar}>
                          Agendar
                        </Link>
                      </div>
                    </div>
                  </article>
                );
              })}
            </div>
          )}
        </div>
      </section>
    </div>
  );
};

export default OurServices;
